import { QuestEditorApi } from "@worldwidewebb/client-quests";
import { axiosInstance, buildQuestClientBasePath } from "..";

const questEditorApi = new QuestEditorApi(undefined, buildQuestClientBasePath(), axiosInstance);

export async function getTaskLocations(): Promise<string[]> {
  try {
    const { data } = await questEditorApi.getTaskLocations();

    if (!data) {
      return [];
    }

    const guis = data as string[];

    return guis.sort((a, b) => a.localeCompare(b));
  } catch (error) {
    console.error(error);
    throw error;
  }
}
